import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import HomeLive from "./HomeLive";
import HomeResults from "./HomeResults";
import HomeRaspored from "./HomeRaspored";
import HomeSponsors from "./HomeSponsors";
import HomeGroups from "./HomeGroups";
import BottomNavigation from "../Navigation/BottomNavigation";
import Navigation from "../Navigation/Navigation";
import HomeFooter from "./HomeFooter";
import HomeBestTeam from "./HomeBestTeam";
// import HomeNews from "./HomeNews";

const extractYear = (naziv) => {
  const match = naziv.match(/\b(20\d{2})\b/);
  return match ? match[0] : naziv;
};

const HomePage = ({ content }) => {
  const { turnirSlug } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("live");
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [currentTurnirId, setCurrentTurnirId] = useState(null);
  const [sveSezone, setSveSezone] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  // 1. Dodano polje features u početni state
  const [turnirInfo, setTurnirInfo] = useState({
    id: null,
    naziv: "",
    logo_url: "",
    lokacija: "",
    naziv_lokacije: "",
    features: {},
    series_slug: "",
  });

  useEffect(() => {
    const fetchTurnirData = async () => {
      let turnirDataResult = null;

      // 2. Dodan "features" u .select() dio prema Supabase tablici
      if (turnirSlug) {
        const { data: turnirData, error: turnirError } = await supabase
          .from("admin_turniri")
          .select(
            "id, naziv, logo_url, lokacija, naziv_lokacije, features, series_slug, slug, datum_od",
          ) // + prošireno
          .eq("slug", turnirSlug)
          .maybeSingle();

        if (turnirError) {
          console.error("Greška kod pronalaska turnira:", turnirError);
        } else if (turnirData) {
          turnirDataResult = turnirData;
        }
      } else {
        const { data: defaultTurnir } = await supabase
          .from("admin_turniri")
          .select(
            "id, naziv, logo_url, lokacija, naziv_lokacije, features, series_slug, slug, datum_od",
          ) // + prošireno
          .order("created_at", { ascending: false })
          .limit(1)
          .maybeSingle();

        if (defaultTurnir) {
          turnirDataResult = defaultTurnir;
        }
      }

      if (turnirDataResult) {
        setCurrentTurnirId(turnirDataResult.id);
        setTurnirInfo({
          id: turnirDataResult.id,
          naziv: turnirDataResult.naziv || "",
          logo_url: turnirDataResult.logo_url || "",
          lokacija: turnirDataResult.lokacija || "",
          naziv_lokacije: turnirDataResult.naziv_lokacije || "",
          features: turnirDataResult.features || {},
          series_slug: turnirDataResult.series_slug || "", // + spremanje series_slug-a
        });

        // + NOVO: dohvat svih sezona koje dijele isti series_slug
        if (turnirDataResult.series_slug) {
          const { data: sezoneData, error: sezoneError } = await supabase
            .from("admin_turniri")
            .select("id, naziv, slug, datum_od")
            .eq("series_slug", turnirDataResult.series_slug);

          if (!sezoneError && sezoneData && sezoneData.length > 0) {
            sezoneData.sort(
              (a, b) => new Date(b.datum_od || 0) - new Date(a.datum_od || 0),
            );
            setSveSezone(sezoneData);
          }
        }
      }
    };

    fetchTurnirData();
  }, [turnirSlug]);

  const handleSezonaChange = (e) => {
    const selectedSlug = e.target.value;
    if (selectedSlug) {
      // Odmah isprazni podatke da se stare komponente sakriju/resetiraju
      setCurrentTurnirId(null);
      setTurnirInfo({
        id: null,
        naziv: "",
        logo_url: "",
        lokacija: "",
        naziv_lokacije: "",
        features: {},
        series_slug: "",
      });
      navigate(`/${selectedSlug}`);
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const tabParam = queryParams.get("tab");
    const highlight = queryParams.get("highlight");

    if (tabParam) {
      if (tabParam === "results" || tabParam === "rezultati")
        setActiveTab("results");
      else if (tabParam === "schedule" || tabParam === "raspored")
        setActiveTab("schedule");
      else if (tabParam === "groups" || tabParam === "grupe")
        setActiveTab("groups");
    }

    if (highlight) {
      setTimeout(() => {
        const element = document.getElementById(
          `match-${decodeURIComponent(highlight)}`,
        );
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
          element.classList.add("highlight-flash");
        }
      }, 800);
    }
  }, []);

  const renderHomeContent = () => {
    switch (activeTab) {
      case "live":
        return <HomeLive turnirId={currentTurnirId} />;
      case "results":
        return <HomeResults turnirId={currentTurnirId} />;
      case "schedule":
        return <HomeRaspored turnirId={currentTurnirId} />;
      case "groups":
        return (
          <HomeGroups
            turnirId={currentTurnirId}
            activeGroupFromSearch={selectedGroup}
          />
        );
      default:
        return <HomeLive turnirId={currentTurnirId} />;
    }
  };

  return (
    <>
      <Navigation
        setActiveTab={setActiveTab}
        setSelectedGroup={setSelectedGroup}
        turnirSlug={turnirSlug}
        turnirNaziv={turnirInfo.naziv}
        turnirLogo={turnirInfo.logo_url}
        lokacija={turnirInfo.lokacija}
        nazivLokacije={turnirInfo.naziv_lokacije}
        features={turnirInfo.features}
      />

      {/* Izbornik za arhivu / sezone */}
      {sveSezone.length > 1 && (
        <div
          className={`floating-season-container ${isExpanded ? "expanded" : ""}`}
        >
          {!isExpanded ? (
            <button
              className="season-fab-btn"
              onClick={() => setIsExpanded(true)}
              title="Promijeni sezonu"
            >
              <i className="fi fi-br-replace"></i>
              <span className="current-year-badge">
                {extractYear(turnirInfo.naziv)}
              </span>
            </button>
          ) : (
            <div className="season-expanded-box">
              <select
                value={turnirSlug || (sveSezone[0] ? sveSezone[0].slug : "")}
                onChange={(e) => {
                  handleSezonaChange(e);
                  setIsExpanded(false);
                }}
                autoFocus
                onBlur={() => setIsExpanded(false)}
              >
                {sveSezone.map((sezona) => (
                  <option key={sezona.id} value={sezona.slug}>
                    {extractYear(sezona.naziv)}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      )}

      <main className="home-page" style={{ paddingBottom: "80px" }}>
        {!content ? (
          <>
            <div className="home-navigation">
              <button
                className={activeTab === "live" ? "active" : ""}
                onClick={() => setActiveTab("live")}
              >
                Uživo
              </button>
              <button
                className={activeTab === "results" ? "active" : ""}
                onClick={() => setActiveTab("results")}
              >
                Rezultati
              </button>
              <button
                className={activeTab === "schedule" ? "active" : ""}
                onClick={() => setActiveTab("schedule")}
              >
                Raspored
              </button>
              <button
                className={activeTab === "groups" ? "active" : ""}
                onClick={() => setActiveTab("groups")}
              >
                Grupe
              </button>
            </div>
            <div className="home-content">
              {currentTurnirId ? (
                renderHomeContent()
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px",
                    color: "#aaa",
                  }}
                >
                  Učitavanje sezone...
                </div>
              )}
            </div>
          </>
        ) : (
          <div className="home-content">{content}</div>
        )}
        {/* <HomeNews /> */}
      </main>
      <HomeSponsors turnirId={currentTurnirId} />
      <HomeBestTeam turnirId={currentTurnirId} turnirNaziv={turnirInfo.naziv} />
      <HomeFooter />

      <BottomNavigation />
    </>
  );
};

export default HomePage;
